export default "__VITE_ASSET__BQGRwYDV__"